import { AxiosResponse } from 'axios';

import { TransferInstructions } from '../../shared/ts/transfer-instructions';
import httpRequest from '../httpRequest';

const transferInstructionsAPI = {
  getTransferInstructions: async (): Promise<TransferInstructions> => {
    const { data } = (await httpRequest({
      url: `/user/funding-instructions`,
      method: 'GET',
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
    })) as AxiosResponse;

    return {
      accountHolderName: data.account_holder_name,
      bic: data.bic,
      country: data.country,
      iban: data.iban,
      userId: data.user_id,
    };
  },
};

export default transferInstructionsAPI;
